module.exports = __webpack_public_path__ + "img/treatment.049d96ea.png";